import { always, equals, cond, toUpper, pathOr } from 'ramda';
import React from 'react';
import {
  RESIDENTIAL_MORTGAGE,
  MERCHANTCASHADVANCES,
  SMALL_BUSINESS,
  CONSUMER_LOAN,
  PERSONALLOANS,
  COMMERCIAL,
  CARDS,
  DEPOSIT_ACCOUNTS
} from 'src/features/LoansHome/Products/constants';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import NewResidentialMortgage from 'src/assets/icons/icon_home.svg';
import NewMerchantCashAdvances from 'src/assets/icons/business_funding.svg';
import NewSmallBusinessLoan from 'src/assets/icons/small_business.svg';
import Other from 'src/assets/icons/other_icon.svg';
import PersonalLoan from 'src/assets/icons/icon_secured.svg';
import Accounts from 'src/assets/icons/credit_card_bonus.svg';
import Cards from 'src/assets/icons/credit-card.svg';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

interface Props {
  appOption: string;
  onSubmit: (productDetails: any, desc: any) => void;
  active?: any;
  isDescriptionText?: boolean;
}
type Alignment = "start" | "end" | "left" | "right" | "center" | "justify" | "match-parent";


type CombinedProps = Props & RouteComponentProps<{}>;

export const useProductOptionStyles = (active: boolean, showCardHorizonal?: boolean, descriptionAlignment: Alignment = 'left', isDescriptionText?: boolean) =>
  makeStyles((theme: Theme) =>
    createStyles({
      card: {
        backgroundColor: active
          ? theme.palette.cardBackground
          : theme.palette.mainLight,
        border: `1px solid ${active ? theme.palette.primaryColor : theme.palette.basic.softGrey
          }`,
        padding: showCardHorizonal ? '24px 29px' : '70px 32px 32px',
        width: showCardHorizonal ? '100%' : '200px',
        display: 'flex',
        flexDirection: showCardHorizonal ? 'row' : 'column',
        justifyContent: showCardHorizonal ? 'start' : 'center',
        alignItems: 'center',
        marginRight: '10px',
        marginLeft: theme.breakpoints.down('md') ? '0' : '10px',
        marginBottom: showCardHorizonal ? '13px' : '20px',
        boxSizing: 'border-box',
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '5px',
        height: showCardHorizonal ? 159 : 'inherit',
        maxWidth: showCardHorizonal ? '500px' : 'inherit',

        '& svg': {
          fill: active
            ? theme.palette.primaryColor
            : theme.palette.basic.lightGrey,
          width: showCardHorizonal ? 79 : 'inherit',
          height: showCardHorizonal ? 50 : 'inherit',
          [theme.breakpoints.down('md')]: {
            width: 34,
            height: 30,
          }
        },

        '&:hover': {
          borderColor: theme.palette.primaryColor,
          backgroundColor: theme.palette.purple.extraLight,
          cursor: 'pointer',
          boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.1)',
          textTransform: "none",
          letterSpacing: "normal",
          '& svg': {
            fill: theme.palette.primaryColor + '!important',
          },

          '& span': {
            display: 'block',
          },
        },
        [theme.breakpoints.down('md')]: {
          width: '100%',
          flexDirection: 'row',
          padding: '19px 16px',
          justifyContent: 'start',
          height: 120,
        },
      },
      cardItemContainer:{
        width: showCardHorizonal ? "inherit" : "auto",
        display:"inherit",
        flexDirection:"inherit",
        justifyContent: "inherit",
        alignItems: 'inherit',
        [theme.breakpoints.down('md')]: {
          marginLeft:"16%" //empirical
        },
      },
      iconWrapper: {
        [theme.breakpoints.down('md')]: {
          width: 34,
          height: 30,
          margin: '10px 6px',
        }
      },
      paletteCreditCard: {
        fill: active
          ? theme.palette.primaryColor
          : theme.palette.card.platinum + '!important',
      },
      businessCreditCard: {
        fill: active
          ? theme.palette.primaryColor
          : theme.palette.card.business + '!important',
      },
      fleetCreditCard: {
        fill: active
          ? theme.palette.primaryColor
          : theme.palette.card.fleet + '!important',
      },
      purchaseCreditCard: {
        fill: active
          ? theme.palette.primaryColor
          : theme.palette.gray.darkGray + '!important',
      },
      homeBuyingOption: {
        [theme.breakpoints.down('md')]: {
          width: '80px !important',
        },
      },
      titleContainer: {
        display: 'flex',
        justifyContent: showCardHorizonal ? 'flex-start' : 'center',
        [theme.breakpoints.down('md')]: {
          justifyContent: 'flex-start',
        },
      },
      title: {
        width:"fit-content !important",
        fontWeight: active || showCardHorizonal ? 600 : 400,
        textAlign: showCardHorizonal ? 'left' : 'center',
        marginLeft: showCardHorizonal ? theme.spacing(3) : 0,
        [theme.breakpoints.down('md')]: {
          textAlign: 'left',
          maxWidth:"160px",
          marginLeft: theme.spacing(2),
          whiteSpace:"nowrap",
          overflow:"hidden",
          textOverflow:"ellipsis"
        },
      },
      description: {
        fontWeight: active ? 600 : 400,
        textAlign: descriptionAlignment,
        fontSize: 14,
        marginLeft: showCardHorizonal ? theme.spacing(3) : 0,
        marginTop: theme.spacing(0.5),
        width: showCardHorizonal ? 'calc(100% - 29px)' : 'calc(100% - 32px)',
        [theme.breakpoints.down('md')]: {
          marginLeft: theme.spacing(2),
          width: 'calc(100% - 16px)'
        },
      },
      descriptionTruncate: {
        display: '-webkit-box !important',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical',
        whiteSpace: 'normal',
        width: '100%',
        [theme.breakpoints.down('md')]: {
          '-webkit-line-clamp': '3',
        },
      },
      lines: {
        height: '12px',
        width: '32px',
        margin: 'auto',
        position: showCardHorizonal ? 'absolute' : 'inherit',
        bottom: showCardHorizonal ? -17 : 'inherit',
        left: showCardHorizonal ? 'calc(50% - 16px)' : 'inherit',
        marginBottom: showCardHorizonal ? 0 : theme.spacing(3),

        '& span': {
          display: active ? 'block' : 'none',
        },

        [theme.breakpoints.down('md')]: {
          position: 'absolute',
          bottom: -23,
          left: 'calc(50% - 16px)',
          marginBottom: 0,
        },
      },
      topLine: {
        width: '32px',
        height: '3px',
        borderRadius: '4px',
        backgroundColor: theme.palette.green,
        marginBottom: showCardHorizonal ? theme.spacing(0.5) : theme.spacing(1),
        [theme.breakpoints.down('md')]: {
          marginBottom: theme.spacing(0.5),
        },
      },
      botLine: {
        width: '16px',
        borderRadius: '4px',
        height: '3px',
        margin: '0 auto',
        backgroundColor: theme.palette.green,
      },
      helpIcon: {
        width: '24px !important',
        height: '24px !important',
      }
    })
  );
const ProductOption: React.FC<CombinedProps> = (props) => {
  const { appOption, onSubmit, active } = props;
  const desc = pathOr('', ['product_visual_name'], appOption);
  const productName = pathOr('', ['product_name'], appOption);
  const id = pathOr('', ['id'], appOption);
  const classes = useProductOptionStyles(active)();
  return (
    <Box className={classes.card} onClick={() => onSubmit({ id, product_name: productName }, desc)}>
      <Box position="relative">
        {appOptionAsVisual(productName)}
        <Box className={classes.lines}>
          <Box component="span" className={classes.topLine} />
          <Box component="span" className={classes.botLine} />
        </Box>
      </Box>
      <Typography className={classes.title}>{desc}</Typography>
    </Box>
  );
};

const appOptionAsVisual = (product: string) => {
  return cond([
    [equals(RESIDENTIAL_MORTGAGE), always(<NewResidentialMortgage />)],
    [equals(MERCHANTCASHADVANCES), always(<NewMerchantCashAdvances />)],
    [equals(CONSUMER_LOAN), always(<NewSmallBusinessLoan />)],
    [equals(SMALL_BUSINESS), always(<NewSmallBusinessLoan />)],
    [equals(DEPOSIT_ACCOUNTS), always(<Accounts />)],
    [equals(CARDS), always(<Cards />)],
    [equals(PERSONALLOANS), always(<PersonalLoan />)],
    [equals(COMMERCIAL), always(<Other />)],
  ])(toUpper(product));
};

export default compose(withRouter)(ProductOption);
